// extracted by mini-css-extract-plugin
export default {"root":"bfZHW","variant-solid":"u4qwp","variantSolid":"u4qwp","variant-outline":"Uy_dS","variantOutline":"Uy_dS"};